/**
 * Collection Presenter
 */
class CollectionPresenter extends AbstractProductsPresenter {

	constructor() {

		super();
		
		this.view = new CollectionView(this);
		this.sectionName = "collection-section";

		/*
		 * Listeners
		 */

		$(document).on(Model.SECTION_RETRIEVED, $.proxy(function(_event, sectionName, section) {
			if (this.sectionName === sectionName) {
				this.view.addSection(section);
				this.retrieveNextSection();
			}
		}, this));

		/*
		 * Initialisation
		 */

		// retrieve the next collection section (if required)
		this.retrieveNextSection();

	}

	/*
	 * Actions
	 */

	retrieveNextSection() {
		
		// get the next page and if we have a value
		var nextPage = this.view.getNextPage();
		if (nextPage != null && nextPage.length > 0) {
			// call for the next section
			$(document).trigger(Model.RETRIEVE_SECTION, [this.sectionName, nextPage]);
		}
		else {
			// enable sorting and filtering controls
			this.view.enableFilteringAndSorting();
		}

	}

}